

































































































import CompSelectBox from '@/components/common/CompSelectBox.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {changeDateFormat, getToday, getStrDate} from '@/utils/dateUtils';
import {Vue, Component} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import {formatCurrency} from '@/utils/formatUtils';
import {i18nInObjectList} from '@/utils/i18n';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';
import {
  Mall,
  GetHolidaysYearRequest,
  GetSettlementsMonthlyRequest,
  GetSettlementsRequest,
  GetSettlementsExcelRequest,
  GetSettlementsPartnersExcelRequest,
  OrderFriendsPartnerType,
  GetSettlementsMonthly
} from 'supporter';
import TuiCalendar from 'tui-calendar';
import {toI18n} from '@/utils/commonUtils';

const mallModule = namespace('mall');
const termsModule = namespace('terms');
@Component({
  components: {CompSelectBox, ItemTable}
})
export default class SettlementList extends Vue {
  @termsModule.Mutation('SET_NCPLAYERISEXIST') private setPopIsExist!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_NCPLAYERISSHOW') private setPopIsShow!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_POPINFO') private setPopInfo!: (popInfo: {title: string, subStyle: string, noticeBox: string}) => void;
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: string = '';
  private countryCode: string = '';
  private get mallList() {
    let res: any = [];
    if (this.malls) {
      this.malls.forEach((mall) => {
        if (mall.used) {
          res.push({
            value: mall.mallNo.toString(),
            name: mall.mallName
          });
        }
      });
    }
    return res;
  }

  // 파트너구분
  private partnerType: string = '';
  private partnerTypes = [
    {
      value: '',
      name: 'COMMON_ALL'
    },
    {
      value: 'DOMESTIC',
      name: 'SETTLEMENT_PARTNER_TYPE_DOMESTIC'
    },
    {
      value: 'OVERSEAS',
      name: 'SETTLEMENT_PARTNER_TYPE_OVERSEAS'
    }
  ];

  // 기간
  private year: number = new Date().getFullYear();
  private selectYear: number = new Date().getFullYear();
  private beginYear: number = new Date().getFullYear() - 5 >= 2018 ? new Date().getFullYear() - 5 : 2018;
  private get yearList() {
    let years = [];
    let nextYear = new Date().getFullYear() + 1;
    for (let i = this.beginYear; i <= nextYear; i++) {
      years.push({
        value: i,
        name: `${i} ${this.$t('COMMON_YEAR')}`
      });
    }

    return years;
  }
  private month: number = new Date().getMonth() + 1;
  private selectMonth: number = new Date().getMonth() + 1;
  private get monthList() {
    let months = [];
    for (let i = 1; i <= 12; i++) {
      months.push({
        value: i,
        name: `${i} ${this.$t('COMMON_MONTH')}`
      });
    }

    return months;
  }

  // 조회
  private afterDetail = false;
  private onClickSearchBtn() {
    this.setCurrentYearMonth();
    this.searchSummary();
  }
  private setCurrentYearMonth(type?: any) {
    if (type === 'prev') {
      this.year = this.month - 1 === 0 ? this.year - 1 : this.year;
      this.month = this.month - 1 === 0 ? 12 : this.month - 1;
      this.selectYear = this.year;
      this.selectMonth = this.month;
    } else if (type === 'next') {
      this.year = this.month + 1 === 13 ? this.year + 1 : this.year;
      this.month = this.month + 1 === 13 ? 1 : this.month + 1;
      this.selectYear = this.year;
      this.selectMonth = this.month;
    } else {
      this.year = this.selectYear;
      this.month = this.selectMonth;
    }
  }
  private async searchSummary() {
    let tempDate = new Date(this.year, this.month - 1, 1);
    this.renderMonth = changeDateFormat(getStrDate(tempDate), 'YYYY.MM');
    this.tuiCalendar.setDate(tempDate);

    let request: GetSettlementsMonthlyRequest = {
      params: {
        mallNo: Number(this.mallNo),
        year: this.year,
        month: this.month
      }
    };
    if (this.partnerType !== '') {
      request.params.partnerType = this.partnerType as OrderFriendsPartnerType;
    }

    let {data} = await this.$api.getSettlementsMonthly(request);

    this.tuiCalendar.clear();
    let summary = [];
    let domestic = data.find((item: GetSettlementsMonthly) => item.countryCode === this.countryCode);
    let overseas = data.find((item: GetSettlementsMonthly) => item.countryCode !== this.countryCode);
    if (domestic) {
      summary.push(...this.createSettlementData(domestic));
    }
    if (overseas) {
      summary.push(...this.createSettlementData(overseas));
    }
    // 휴일 설정.
    this.tuiCalendar.createSchedules(summary.concat(this.holidayData));
    this.tuiCalendar.render();
    this.afterDetail = false;
  }
  private createSettlementData(summary: any): any[] {
    let settlementInfo = summary.settlementsInfo;
    let result = [];
    let periodData = {
      title: `${this.getPeriodTypeName(settlementInfo.periodType)}: ${settlementInfo.settlementsPeriod.replace(/[{}]+/g, '')}`,
      category: 'allday',
      start: settlementInfo.settlementsFormatDate,
      end: settlementInfo.settlementsFormatDate,
      isReadOnly: true,
      color: 'white',
      bgColor: settlementInfo.settlementsState === 'CONFIRM' ? '#4B96FF' : '#FF5D15',
      borderColor: settlementInfo.settlementsState === 'CONFIRM' ? '#4B96FF' : '#FF5D15',
      customStyle: 'cursor: default;'
    };

    let amtData = {
      title: `${this.$t('SETTLEMENT_LIST_ESTIMATED_AMT')}: ${formatCurrency(summary.settlementAmt)}${this.$t('COMMON_WON')}`,
      category: 'allday',
      start: settlementInfo.settlementsFormatDate,
      end: settlementInfo.settlementsFormatDate,
      isReadOnly: true,
      color: 'white',
      bgColor: settlementInfo.settlementsState === 'CONFIRM' ? '#4B96FF' : '#FF5D15',
      raw: summary,
      customStyle: 'text-decoration: underline;',
      borderColor: settlementInfo.settlementsState === 'CONFIRM' ? '#4B96FF' : '#FF5D15'
    };
    result.push(periodData);
    result.push(amtData);
    return result;
  }

  // 초기화
  private resetAll() {
    this.mallNo = this.malls[0].mallNo.toString();
    this.countryCode = this.malls[0].countryCode;
    this.partnerType = '';
    this.selectYear = new Date().getFullYear();
    this.selectMonth = new Date().getMonth() + 1;
  }

  // Calender
  private holidayData: any[] = [];
  private tuiCalendar: any;
  private renderMonth = changeDateFormat(getToday(), 'YYYY.MM');
  private get weeksName(): string[] {
    return [
      this.$t('COMMON_SUN_SHOR') as string,
      this.$t('COMMON_MON_SHOR') as string,
      this.$t('COMMON_TUE_SHOR') as string,
      this.$t('COMMON_WED_SHOR') as string,
      this.$t('COMMON_THU_SHOR') as string,
      this.$t('COMMON_FRI_SHOR') as string,
      this.$t('COMMON_SAT_SHOR') as string
    ];
  }
  private get showToday() {
    let week = Number(changeDateFormat(getToday(), 'd'));
    let today = changeDateFormat(getToday(), 'YYYY.MM.DD');
    return `${today} (${this.weeksName[week]})`;
  }
  private get prveDisabled() {
    let flg = false;
    if (this.year === this.beginYear && this.month === 1) {
      flg = true;
    }
    return flg;
  }
  private get nextDisabled() {
    let flg = false;
    let nextYear = new Date().getFullYear() + 1;
    if (this.year === nextYear && this.month === 12) {
      flg = true;
    }
    return flg;
  }
  private async moveMonth(type: string) {
    if (type === 'prev') {
      await this.tuiCalendar.prev();
    } else {
      await this.tuiCalendar.next();
    }
    this.setCurrentYearMonth(type);
    this.searchSummary();
  }
  private initCalender() {
    let _this = this;
    this.tuiCalendar = new TuiCalendar('#calendar', {
      defaultView: 'month',
      theme: {
        'common.border': '1px solid #e5e5e5',
        'common.backgroundColor': 'white',
        'common.holiday.color': '#ff4040',
        'common.saturday.color': '#135de6',
        'common.dayname.color': '#333',
        'common.today.color': '',

        // creation guide style
        'common.creationGuide.backgroundColor': 'rgba(81, 92, 230, 0.05)',
        'common.creationGuide.border': '1px solid #515ce6',

        // month header 'dayname'
        'month.dayname.height': '31px',
        'month.dayname.borderLeft': '1px solid #e5e5e5',
        'month.dayname.paddingLeft': '10px',
        'month.dayname.paddingRight': '10px',
        'month.dayname.backgroundColor': 'inherit',
        'month.dayname.fontSize': '12px',
        'month.dayname.fontWeight': 'normal',
        'month.dayname.textAlign': 'left',

        // month day grid cell 'day'
        'month.holidayExceptThisMonth.color': 'rgba(255, 64, 64, 0.4)',
        'month.dayExceptThisMonth.color': 'rgba(51, 51, 51, 0.4)',
        'month.weekend.backgroundColor': 'inherit',
        'month.day.fontSize': '14px',

        // month schedule style
        'month.schedule.borderRadius': '0px',
        'month.schedule.height': '20px',
        'month.schedule.marginTop': '0px',
        'month.schedule.marginLeft': '0px',
        'month.schedule.marginRight': '0px'
      },
      month: {
        daynames: this.weeksName,
        moreLayerSize: {
          height: 'auto'
        },
        grid: {
          footer: {
            height: 10
          }
        }
      },
      template: {
        monthGridHeader: (model: any) => {
          let date = new Date(model.date);
          let template = `<span class="tui-full-calendar-weekday-grid-date">${date.getDate()}</span>`;
          if (model.isToday) {
            template += `<span class="tag custom-today">${window.$t('COMMON_TODAY')}</span>`;
          }
          return template;
        }
      }
    });
    this.tuiCalendar.on({
      clickSchedule: function (e: any) {
        let summary = e.schedule.raw;
        if (!summary) {
          return;
        }
        let settlementsInfo = summary.settlementsInfo;
        // 색상 초기화.
        $('.tui-full-calendar-weekday-schedule').removeClass('custom-select');
        $(e.event.target).parent().addClass('custom-select');
        $(e.event.target)
          .parent()
          .addClass(e.schedule['bgColor'] === '#4B96FF' ? 'confirm' : 'pending');

        _this.searchDetailData = {
          mallNo: Number(summary.mallNo),
          year: settlementsInfo.year,
          month: settlementsInfo.month,
          partnerType: summary.countryCode === 'KR' ? 'DOMESTIC' : 'OVERSEAS',
          settlementDate: settlementsInfo.settlementsFormatDate
        };

        _this.afterDetail = true;
        _this.searchDetail();
      },
      beforeCreateSchedule: function (e: any) {
        e.guide.clearGuideElement();
      }
    });
  }
  private async initHoliday() {
    let holidays = [];
    let request: GetHolidaysYearRequest = {
      pathParams: {
        year: this.beginYear.toString()
      }
    };
    for (let i = this.beginYear; i <= new Date().getFullYear() + 1; i++) {
      request = {
        pathParams: {
          year: i.toString()
        }
      };
      let {data} = await this.$api.getHolidaysYear(request);
      holidays.push(...data);
    }
    this.holidayData.push(
      ...holidays.map((holiday: any) => {
        return {
          id: holiday.holiday,
          calendarId: holiday.holiday,
          title: holiday.holidayName,
          category: 'allday',
          start: holiday.holiday,
          end: holiday.holiday,
          isReadOnly: true,
          color: '#9a1313',
          bgColor: 'rgba(218,27,27,0.2)',
          customStyle: 'text-decoration: underline; margin: 0px 10px; cursor: default;',
          borderColor: '#da1b1b',
          isVisible: true
        };
      })
    );
  }

  // 정산예상금액 상세
  private pageSize: number = 30;
  private gridProps = {
    options: {
      rowHeaders: ['rowNum'],
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      displayRowCount: 30,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    },
    header: {},
    columns: [
      {
        header: 'SETTLEMENT_LIST_HEADER_DATE',
        name: 'settlementDate',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_PERIOD_TYPE',
        name: 'settlementPeriodType',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_STATE',
        name: 'settlementState',
        align: 'center',
        minWidth: 60
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_PERIOD',
        name: 'settlementPeriod',
        align: 'center',
        minWidth: 200
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_PARTNER_NAME',
        name: 'partnerName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_PARTNER_TYPE',
        name: 'partnerType',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_SALES_AMT',
        name: 'salesAmt',
        align: 'right',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_COMMISSION_AMT',
        name: 'commissionAmt',
        align: 'right',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_DELIVERY_AMT',
        name: 'deliveryAmt',
        align: 'right',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_PARTNER_DISCOUNT_AMT',
        name: 'partnerDiscountAmt',
        align: 'right',
        minWidth: 180
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_DEDUCTED_AMT',
        name: 'deductedAmt',
        align: 'right',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_AMT',
        name: 'settlementAmt',
        align: 'right',
        minWidth: 180
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_BANK_NAME',
        name: 'bankName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_TRADE_BANK_ACCOUNT',
        name: 'tradeBankAccount',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_TRADE_BANK_DEPOSITOR_NAME',
        name: 'tradeBankDepositorName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'SETTLEMENT_LIST_HEADER_EXCEL_BTN',
        name: 'excelBtn',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return `<button type="button" class="excelBtn downloadPartner" data-partner-no="${cell.row.partnerNo}" data-partner-name="${cell.row.partnerName}">${window.$t('COMMON_DOWNLOAD')}</button>`;
        }
      }
    ]
  };
  private gridData: any[] = [];
  private totalCount: number = 0;
  private contentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    onLoadSearch: false
  };
  private searchDetailData = {
    mallNo: 0,
    year: 0,
    month: 0,
    partnerType: '',
    settlementDate: ''
  };
  private async searchDetail(page: number = 1, size?: number) {
    if (size) {
      this.pageSize = size;
    }
    if (this.afterDetail) {
      let request: GetSettlementsRequest = {
        params: {
          mallNo: this.searchDetailData.mallNo,
          year: this.searchDetailData.year,
          month: this.searchDetailData.month,
          page,
          size: this.pageSize
        }
      };
      if (this.searchDetailData.partnerType !== '') {
        request.params.partnerType = this.searchDetailData.partnerType as OrderFriendsPartnerType;
      }

      let {data} = await this.$api.getSettlements(request);

      this.gridData = this.formatData(data.contents);
      this.totalCount = data.totalCount;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.perPage = this.pageSize;
      this.gridProps.options.pageOptions.totalCount = data.totalCount;
    }
  }
  private formatData(responseData: any[]): any[] {
    return responseData.map((settlement: any) => {
      return {
        settlementDate: settlement.settlementsInfo.settlementsFormatDate,
        settlementPeriodType: this.getPeriodTypeName(settlement.settlementsInfo.periodType),
        settlementState: this.getStateName(settlement.settlementsInfo.settlementsState),
        settlementPeriod: settlement.settlementsInfo.settlementsPeriod.replace(/[{}]+/g, ''),
        partnerName: settlement.partnerInfo.partnerName,
        partnerType: settlement.countryCode === 'KR' ? this.$t('SETTLEMENT_PARTNER_TYPE_DOMESTIC') : this.$t('SETTLEMENT_PARTNER_TYPE_OVERSEAS'),
        salesAmt: formatCurrency(settlement.salesAmt),
        commissionAmt: formatCurrency(settlement.commissionAmt),
        deliveryAmt: formatCurrency(settlement.deliveryAmt),
        partnerDiscountAmt: formatCurrency(settlement.partnerDiscountAmt),
        deductedAmt: formatCurrency(settlement.deductedAmt),
        settlementAmt: formatCurrency(settlement.settlementAmt),
        bankName: settlement.partnerInfo.tradeBankName,
        tradeBankAccount: settlement.partnerInfo.tradeBankAccount,
        tradeBankDepositorName: settlement.partnerInfo.tradeBankDepositorName,
        partnerNo: settlement.partnerNo
      };
    });
  }

  // 다운로드
  private async downloadByPartner(e: any) {
    await this.download('byOption', Number($(e.target).data('partnerNo')), $(e.target).data('partnerName'));
  }
  private async download(type: string, partnerNo?: number, partnerName?: string) {
    if (type === 'byPartner') {
      let createExcelFileQuery = {
        mallNo: this.searchDetailData.mallNo,
        year: this.searchDetailData.year,
        month: this.searchDetailData.month,
        partnerType: this.searchDetailData.partnerType as OrderFriendsPartnerType
      };
      createExcel(this, this.gridData.length > 0, createExcelFileQuery, 'PREMIUM_SETTLEMENT_BY_PARTNER', changeDateFormat(this.searchDetailData.settlementDate, 'YYYYMMDD'));
    } else if (type === 'byOption') {
      let createExcelFileQuery: any = {
        mallNo: this.searchDetailData.mallNo,
        year: this.searchDetailData.year,
        month: this.searchDetailData.month,
        partnerType: this.searchDetailData.partnerType as OrderFriendsPartnerType
      };
      if (partnerNo && partnerName) {
        createExcelFileQuery.partnerNo = partnerNo;
      }
      if (partnerNo && partnerName) {
        createExcel(this, this.gridData.length > 0, createExcelFileQuery, 'PREMIUM_SETTLEMENT_DETAIL', partnerName);
      } else {
        createExcel(this, this.gridData.length > 0, createExcelFileQuery, 'PREMIUM_SETTLEMENT_BY_OPTION', changeDateFormat(this.searchDetailData.settlementDate, 'YYYYMMDD'));
      }
    }
  }
  private async downloadOld(type: string, partnerNo?: number, partnerName?: string) {
    if (this.gridData.length === 0) {
      alert(this.$t('COMMON_NOT_DATA'));
    } else {
      let data: any;
      let fileName = this.$t('SETTLEMENT_LIST_EXCEL_NAME') as string;
      if (type === 'byPartner') {
        let request: GetSettlementsPartnersExcelRequest = {
          params: {
            mallNo: this.searchDetailData.mallNo,
            year: this.searchDetailData.year,
            month: this.searchDetailData.month,
            partnerType: this.searchDetailData.partnerType as OrderFriendsPartnerType
          }
        };
        let response = await this.$api.getSettlementsPartnersExcel(request);
        data = response.data;
        fileName += '_partner_';
      } else if (type === 'byOption') {
        let request: GetSettlementsExcelRequest = {
          params: {
            mallNo: this.searchDetailData.mallNo,
            year: this.searchDetailData.year,
            month: this.searchDetailData.month,
            partnerType: this.searchDetailData.partnerType as OrderFriendsPartnerType
          }
        };
        if (partnerNo && partnerName) {
          request.params.partnerNo = partnerNo;
        }
        let response = await this.$api.getSettlementsExcel(request);
        data = response.data;
        if (partnerNo && partnerName) {
          fileName += `_${partnerName}_`;
        } else {
          fileName += '_option_';
        }
      }
      fileName += `${changeDateFormat(this.searchDetailData.settlementDate, 'YYYYMMDD')}_${changeDateFormat(new Date(), 'YYYYMMDDHHmmss')}.xlsx`;
      const myBlob = new Blob([data], {type: 'application/octet-stream'});
      const qrUrl = window.URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      const event = new MouseEvent('click');
      a.download = fileName;
      a.href = qrUrl;
      a.dispatchEvent(event);
      window.URL.revokeObjectURL(qrUrl);
    }
  }

  // util
  private getPeriodTypeName(periodType: string): string {
    let periodTypeName = '';
    if (periodType === 'MONTH') {
      periodTypeName = this.$t('SETTLEMENT_LIST_PERIOD_TYPE_MONTH') as string;
    } else if (periodType === 'WEEK') {
      periodTypeName = this.$t('SETTLEMENT_LIST_PERIOD_TYPE_WEEK') as string;
    } else if (periodType === 'DAY') {
      periodTypeName = this.$t('SETTLEMENT_LIST_PERIOD_TYPE_DAY') as string;
    }
    return periodTypeName;
  }
  private getStateName(settlementState: string): string {
    let stateName = '';
    if (settlementState === 'PENDING') {
      stateName = this.$t('SETTLEMENT_LIST_STATE_PENDING') as string;
    } else if (settlementState === 'CONFIRM') {
      stateName = this.$t('SETTLEMENT_LIST_STATE_CONFIRM') as string;
    }
    return stateName;
  }

  public pDI18n(needToI18nStr: string): string {
    return toI18n(this.$t('SETTLEMENT_LIST_' + needToI18nStr));
  }
  public customColumnHeader = {
    columns: [
      {
        name: 'deductedAmt',
        renderer: ({columnInfo}: any) => {
          const div = document.createElement('div');
          const span = document.createElement('span');
          span.innerText = columnInfo.header;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'help';
          button.style.cssText = 'background: url(/static/ncp/css/img/sp.png) no-repeat -76px 0;';
          button.addEventListener('mousedown', (e): void => {
            const popInfo = {
              title: this.pDI18n('DEDUCTED_AMT_TITLE'),
              subStyle: 'width:640px; max-height:800px; scroll-y:auto',
              noticeBox: `
                <div class="notice_box noIcon">
                  <ul>
                    <li>${this.pDI18n('DEDUCTED_AMT_1')}</li>
                  </ul>
                </div>`
            };
            this.setPopInfo(popInfo);
            this.setPopIsShow(true);
            e.preventDefault();
            e.stopPropagation();
          });
          div.append(span, button);
          return {
            getElement(): any {
              return div;
            },
            render(): void {
              div.append(span, button);
            }
          };
        }
      }
    ]
  };

  private async mounted() {
    await this.fetchMalls();
    this.mallNo = this.malls[0].mallNo.toString();
    this.countryCode = this.malls[0].countryCode;
    await this.initCalender();
    await this.initHoliday();
    await this.searchSummary();
    $('body').on('click', '.downloadPartner', $.proxy(this.downloadByPartner, this));
  }
  private created() {
    const newGridProps = { ...this.gridProps };
    newGridProps.header = { ...this.customColumnHeader };
    this.gridProps = newGridProps;
    this.setPopIsExist(true);
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
}
